module.exports = __webpack_public_path__ + "img/honor1.6708c474.png";